import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "CalculatorTemplatePanel" }
const _hoisted_2 = { class: "CalculatorTemplatePanel__title" }
const _hoisted_3 = { class: "CalculatorTemplatePanel__container" }
const _hoisted_4 = { class: "action__text" }
const _hoisted_5 = {
  key: 0,
  class: "CalculatorTemplatePanel__state"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "action__text" }, "Загрузить еще", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_search = _resolveComponent("icon-search")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_icon_big_plus = _resolveComponent("icon-big-plus")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_template_card = _resolveComponent("template-card")!
  const _component_s_loader = _resolveComponent("s-loader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode(_component_s_input, {
      disabled: _ctx.loading || _ctx.disabled,
      value: _ctx.state.query,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.query = $event)),
      class: "CalculatorTemplatePanel__search",
      placeholder: "Поиск по номеру телефона, адресу или названию",
      onInput: _ctx.onSearch
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_icon_search)
      ]),
      _: 1
    }, 8, ["disabled", "value", "onInput"]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_new_button, {
        disabled: _ctx.disabled,
        class: "container__action button--primary button--small",
        onClick: _ctx.onCreate
      }, {
        default: _withCtx(() => [
          _createVNode(_component_icon_big_plus, { class: "action__create" }),
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.createText), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.templates, (template) => {
        return (_openBlock(), _createBlock(_component_template_card, {
          key: template.id,
          template: template,
          disabled: _ctx.loading || _ctx.disabled,
          selected: _ctx.isTemplateSelected(template),
          "is-receiver-template": _ctx.isReceiverTemplates,
          onSelect: _ctx.onTemplateSelect,
          onUpdate: _ctx.onTemplateUpdate,
          onDelete: _ctx.onTemplateDelete
        }, null, 8, ["template", "disabled", "selected", "is-receiver-template", "onSelect", "onUpdate", "onDelete"]))
      }), 128)),
      (_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_s_loader)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCanLoadMore)
        ? (_openBlock(), _createBlock(_component_new_button, {
            key: 1,
            disabled: _ctx.disabled || _ctx.loading,
            class: "container__action button--primary button--small action__more",
            onClick: _ctx.onLoadMore
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}